import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import customStyles from './IntroMessage.module.css'
import './IntroMessage.css'
import ReactMarkdown from 'react-markdown'

const buttonStyle = {
    backgroundColor: '#345074',
    color: 'white',
    boxShadow: '0 4px 1px #000000',
    width: '250px',
    borderRadius: '8px',
    lineHeight: '2',
    fontSize: '20px',
    fontFamily: 'Lato, sans-serif',
    textTransform: 'none',
    ':hover': { backgroundColor: '#345074' }
}

export default function IntroMessage(props) {
    const [open, setOpen] = React.useState(props.show);

    function handleClose() {
        props.parentCallback && props.parentCallback();
        localStorage.viewIntroMessage = true;
        setOpen(false);
    }

    return (
        <div>
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" maxWidth="md" open={open} PaperProps={{style: { borderRadius: 5 }}}>
                <DialogTitle id="customized-dialog-title" style={{margin: 'auto'}} t={props.t}>
                    <img src={`/${props.vSite.vWebsiteID}/icons/${props.vSite.logoURL}`} alt={''}/>
                    {open ? (
                        <IconButton aria-label={props.t.close} onClick={handleClose} sx={{position: 'absolute', top: '8px', right: '8px'}}>
                            <CloseIcon fontSize={'large'} ></CloseIcon>
                        </IconButton>
                    ) : null}
                </DialogTitle>
                <DialogContent id="dialog-content" style={{color: '#4F5B72', textAlign: 'center'}}>
                    <ReactMarkdown>
                        { props.vSite.description }
                    </ReactMarkdown>
                </DialogContent>
                <DialogActions sx={{margin: 0, padding: '20px', justifyContent: 'center'}}>
                    <Button onClick={handleClose} sx={buttonStyle}>
                        { props.t.startVisit }
                    </Button>
                </DialogActions>
                <DialogContent sx={{backgroundColor: '#e0e0e0', minHeight: '40px'}}>
                    <div className={customStyles.fipContainer}>
                        <img className={customStyles.fipResponsive}
                             src={`/${props.vSite.vWebsiteID}/${props.vSite.FIP.serviceTitlesImageURL}`}
                             alt={props.vSite.FIP.serviceTitles} />
                        <img className={customStyles.fipCanadaLogo}
                             src={"/Images/Fip/Canada_Wordmark_Colour_FIP.png"}
                             alt={''} />
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
